function OverviewCount({ label, count, color, onClick, pressed, title, ariaLabel }) {
  const Tag = onClick ? 'button' : 'div';
  return (
    <Tag
      className="admin-compact-overview__count"
      style={{ '--overview-count-color': color }}
      {...(onClick ? { type: 'button', onClick, 'aria-pressed': pressed, 'aria-label': ariaLabel, title } : {})}
    >
      <span>{label}</span>
      <strong>{count}</strong>
    </Tag>
  );
}

export function AdminCompactOverview({
  maxCapacity, rsvp, coachSeats, sideAttending, trainInterested, trainConfirmed, ceremonyCount,
  theme, filterCeremony, onToggleCeremonyFilter, filterTrainInterested, onToggleTrainInterestedFilter,
  filterTrainConfirmed, onToggleTrainConfirmedFilter, filterRsvpConfirmed, onToggleRsvpConfirmedFilter,
}) {
  const { yes, tentative, confirmed, notInvited, no: declined } = rsvp;
  const attending = yes + tentative + confirmed;
  const balance = [
    ['Ben', sideAttending.ben], ['Meg', sideAttending.meg],
    ['Joint', sideAttending.joint], ['Not set', sideAttending.unspecified],
  ];
  const coaches = [
    ['To estate', '14:30', coachSeats.inbound230],
    ['Return', '22:30', coachSeats.out1030],
    ['Return', '00:30', coachSeats.out1230],
  ];

  return (
    <section className="admin-compact-overview" aria-label="Guest overview">
      <div className="admin-compact-overview__heading">
        <h2>Overview</h2>
        <span><strong>{attending}</strong> / {maxCapacity} attending</span>
      </div>
      <div className="admin-compact-overview__capacity">
        <span style={attending > maxCapacity ? { color: theme.danger } : undefined}>
          {attending > maxCapacity ? `${attending - maxCapacity} over capacity` : `${maxCapacity - attending} spaces left`}
        </span>
        <span>{notInvited} not yet invited</span>
      </div>
      <div className="admin-compact-overview__rsvps">
        <OverviewCount label="Confirmed" count={confirmed} color={theme.rsvp.confirmed}
          onClick={onToggleRsvpConfirmedFilter} pressed={filterRsvpConfirmed}
          ariaLabel={`RSVP confirmed: ${confirmed}`}
          title="Filter the guest list to RSVP confirmed (form) only. Click again to clear." />
        <OverviewCount label="Verbal yes" count={yes} color={theme.rsvp.confirmed} />
        <OverviewCount label="Tentative" count={tentative} color={theme.rsvp.pending} />
        <OverviewCount label="Declined" count={declined} color={theme.rsvp.declined} />
      </div>
      <div className="admin-compact-overview__travel">
        <OverviewCount label="Ceremony" count={ceremonyCount} color={theme.indigo}
          onClick={onToggleCeremonyFilter} pressed={filterCeremony}
          ariaLabel={`Ceremony guests: ${ceremonyCount}`}
          title="Filter the guest list to ceremony guests only (same as SITE → Ceremony). Click again to clear." />
        <OverviewCount label="Train interested" count={trainInterested} color={theme.accent}
          onClick={onToggleTrainInterestedFilter} pressed={filterTrainInterested}
          ariaLabel={`Train interested: ${trainInterested}`}
          title="Show guests who chose Yes for train. Tap again to clear." />
        <OverviewCount label="Train confirmed" count={trainConfirmed} color={theme.rsvp.confirmed}
          onClick={onToggleTrainConfirmedFilter} pressed={filterTrainConfirmed}
          ariaLabel={`Train confirmed: ${trainConfirmed}`}
          title="Show guests with a numbered train booking tag (train - X). Tap again to clear." />
      </div>
      <div className="admin-compact-overview__balance" aria-label="Attending guest balance">
        {balance.map(([label, count]) => <span key={label}>{label} <strong>{count}</strong></span>)}
      </div>
      <div className="admin-compact-overview__coaches" aria-label="Coach seats">
        {coaches.map(([label, time, count]) => (
          <span key={time}>
            <span>{label}</span>
            <span>{time} <strong>{count}</strong></span>
          </span>
        ))}
      </div>
    </section>
  );
}
